import { FormGroup, Label, Input, Button } from "reactstrap";

const Step1 = (props) => {
  if (props.currentStep !== 1) {
    return null;
  }

  return (
    <>
      <div className="centerr">
        <h4>{props.stepTitle}</h4>
      </div>
      <FormGroup>
        <Label for="titulo">Titulo:</Label>
        <Input
          type="text"
          name="title"
          id="titulo"
          placeholder="Escreva o título da página"
          value={props.title}
          onChange={props.handlePageChange}
        />
        <Label className="mt-4" for="titulo">
          Descrição:
        </Label>
        <Input
          type="text"
          name="description"
          id="description"
          placeholder="Escreva a descrição da página"
          value={props.description}
          onChange={props.handlePageChange}
        />
      </FormGroup>
      {props.isEditing && (
        <div className="centerr">
          <Button onClick={props.update} className="mt-4">
            Atualizar
          </Button>
        </div>
      )}
    </>
  );
};

export default Step1;
